import {
  ProductProfitStatisticsState,
  REQUEST_STOREPROFITSTATISTICS_BY_PRODUCT,
  REQUEST_STOREPROFITSTATISTICS_BY_PRODUCT_DONE
} from "./types";

const initialState: ProductProfitStatisticsState = {
  isLoading: true,
  productProfitStatistics: []
};

export function reducer(state = initialState, action: any) {
  switch (action.type) {
    case REQUEST_STOREPROFITSTATISTICS_BY_PRODUCT:
      return {
        isLoading: true,
        productProfitStatistics: action.payload
      };
    case REQUEST_STOREPROFITSTATISTICS_BY_PRODUCT_DONE:
      return {
        isLoading: false,
        productProfitStatistics: action.payload
      };
    default:
      return state;
  }
}
